module.exports = __webpack_public_path__ + "img/xiangQing.0780f639.jpg";